import React from 'react';
export function Footer() {
  return <footer className="py-8 px-6 bg-[#0a0807] text-cream/40 text-center text-sm border-t border-white/5" data-id="element-94">
      <p data-id="element-95">
        © {new Date().getFullYear()} La Ansiedad Es Tu Síntoma, No Tu
        Identidad. Todos los derechos reservados.
      </p>
      <p className="mt-2 text-xs" data-id="element-96">
        Este producto no reemplaza el tratamiento médico o psicológico
        profesional.
      </p>
    </footer>;
}